import DetailCashDeposit from "../pages/tellerOperations/cashDeposit/DetailCashDeposit";
import ManageCashDeposit from "../pages/tellerOperations/cashDeposit/ManageCashDeposit";
import NewCashDeposit from "../pages/tellerOperations/cashDeposit/NewCashDeposit";
import DetailCashWithdrawal from "../pages/tellerOperations/cashWithdrawal/DetailCashWithdrawal";
import ManageCashWithdrawal from "../pages/tellerOperations/cashWithdrawal/ManageCashWithdrawal";
import NewCashWithdrawal from "../pages/tellerOperations/cashWithdrawal/NewCashWithdrawal";
import DetailChequeDeposit from "../pages/tellerOperations/chequeDeposit/DetailChequeDeposit";
import ManageChequeDeposit from "../pages/tellerOperations/chequeDeposit/ManageChequeDeposit";
import NewChequeDeposit from "../pages/tellerOperations/chequeDeposit/NewChequeDeposit";
import DetailChequeWithdrawal from "../pages/tellerOperations/chequeWithdrawal/DetailChequeWithdrawal";
import ManageChequeWithdrawal from "../pages/tellerOperations/chequeWithdrawal/ManageChequeWithdrawal";
import NewChequeWithdrawal from "../pages/tellerOperations/chequeWithdrawal/NewChequeWithdrawal";
import DetailTransactionPurchase from "../pages/tellerOperations/foreignExchange/fxTransactionPurchase/DetailTransactionPurchase";
import ManageTransactionPurchase from "../pages/tellerOperations/foreignExchange/fxTransactionPurchase/ManageTransactionPurchase";
import NewTransactionPurchase from "../pages/tellerOperations/foreignExchange/fxTransactionPurchase/NewTransactionPurchase";
import DetailTransactionSales from "../pages/tellerOperations/foreignExchange/fxTransactionSales/DetailTransactionSales";
import ManageTransactionSales from "../pages/tellerOperations/foreignExchange/fxTransactionSales/ManageTransactionSales";
import NewTransactionSales from "../pages/tellerOperations/foreignExchange/fxTransactionSales/NewTransactionSales";
import LinkUserToTillTellerConfig from "../pages/tellerOperations/linkUsertoTill/LinkUserToTill";
import BranchBatch from "../pages/tellerOperations/branchBatch/BranchBatch";
import Teller from "../pages/tellerOperations/linkUsertoTill/Teller";
import TellerConfigDetail from "../pages/tellerOperations/linkUsertoTill/TellerConfigDetail";
import NewTeller from "../pages/tellerOperations/linkUsertoTill/NewTeller";
import DetailTeller from "../pages/tellerOperations/linkUsertoTill/DetailTeller";
import EditTeller from "../pages/tellerOperations/linkUsertoTill/EditTeller";
import TLO0600 from "../pages/tellerOperations/requestCash/RequestCash";
import TLO0500 from "../pages/tellerOperations/sendCash/SendCash";
import VaultBatch from "../pages/tellerOperations/vaultBatch/VaultBatch";
import TellerBatch from "../pages/tellerOperations/tellerBatch/TellerBatch";
import TellerTransactions from "../pages/tellerOperations/tellerTransactions/ManageTellerTransactions";
import ReceiveTellerTransaction from "../pages/tellerOperations/tellerTransactions/ReceiveTellerTransaction";
// import ReceiveTellerTransaction from "../pages/tellerOperations/branchBatch/BranchBatch";
import FundsTransfer from "../pages/tellerOperations/fundsTransfer/FundsTransfer";

export default [
  // CASH DEPOSIT
  {
    path: "/tlo0800",
    component: NewCashDeposit,
    isProtected: true,
  },
  // {
  //   path: "/new-tlo0800",
  //   component: NewCashDeposit,
  //   isProtected: true,
  // },
  // {
  //   path: "/detail-tlo0800",
  //   component: DetailCashDeposit,
  //   isProtected: true,
  // },

  // CASH WITHDRAWAL
  {
    path: "/tlo0900",
    component: NewCashWithdrawal,
    isProtected: true,
  },
  // {
  //   path: "/detail-tlo0900",
  //   component: DetailCashWithdrawal,
  //   isProtected: true,
  // },

  // {
  //   path: "/new-tlo0900",
  //   component: NewCashWithdrawal,
  //   isProtected: true,
  // },
  // CHEQUE DEPOSIT
  {
    path: "/tlo1000",
    component: NewChequeDeposit,
    isProtected: true,
  },
  // {
  //   path: "/new-tlo1000",
  //   component: NewChequeDeposit,
  //   isProtected: true,
  // },
  // {
  //   path: "/detail-tlo1000",
  //   component: DetailChequeDeposit,
  //   isProtected: true,
  // },

  // CHEQUE WITHDRAWAL
  {
    path: "/tlo1100",
    component: NewChequeWithdrawal,
    isProtected: true,
  },
  // {
  //   path: "/detail-tlo1100",
  //   component: DetailChequeWithdrawal,
  //   isProtected: true,
  // },

  // {
  //   path: "/new-tlo1100",
  //   component: NewChequeWithdrawal,
  //   isProtected: true,
  // },
  // FX-Transaction sales
  {
    path: "/tlo1200",
    component: ManageTransactionSales,
    isProtected: true,
  },
  {
    path: "/detail-transaction-sales",
    component: DetailTransactionSales,
    isProtected: true,
  },
  {
    path: "/new-transaction-sales",
    component: NewTransactionSales,
    isProtected: true,
  },

  // FX-Transaction PURCHASE
  {
    path: "/tlo1201",
    component: ManageTransactionPurchase,
    isProtected: true,
  },
  {
    path: "/detail-transaction-purchase",
    component: DetailTransactionPurchase,
    isProtected: true,
  },
  {
    path: "/new-transaction-purchase",
    component: NewTransactionPurchase,
    isProtected: true,
  },

  // linkuser to till
  {
    path: "/tlo0100",
    component: LinkUserToTillTellerConfig,
    isProtected: true,
  },
  {
    path: "/tlo0200",
    component: BranchBatch,
    isProtected: true,
  },
  {
    path: "/tlo0300",
    component: VaultBatch,
    isProtected: true,
  },
  {
    path: "/funds-transfer",
    component: FundsTransfer,
    isProtected: true,
  },
  // Link User to till teller config
  {
    path: "/detail-tlo0100",
    component: Teller,
    isProtected: true,
  },
  {
    path: "/tlo0100/till",
    component: TellerConfigDetail,
    isProtected: true,
  },
  {
    path: "/new-teller",
    component: NewTeller,
    isProtected: true,
  },
  {
    path: "/detail-teller",
    component: DetailTeller,
    isProtected: true,
  },
  {
    path: "/edit-teller",
    component: EditTeller,
    isProtected: true,
  },
  // send cash
  {
    path: "/tlo0500",
    component: TLO0500,
    isProtected: true,
  },

  {
    path: "/tlo0600",
    component: TLO0600,
    isProtected: true,
  },
  {
    path: "/tlo0400",
    component: TellerBatch,
    isProtected: true,
  },
  {
    path: "/tlo0700",
    component: TellerTransactions,
    isProtected: true,
  },
  {
    path: "/receive-teller-transaction",
    component: ReceiveTellerTransaction,
    isProtected: true,
  },
];
